<template>
  <v-container>
    <v-data-table-server
      v-model:items-per-page="pagination.limit"
      :items="emailTemplates"
      :headers="headers"
      :items-length="count"
      :loading="loading"
      :search="pagination.q"
      item-key="id"
      @update:options="handleLimitChange">
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          :to="{ name: 'AdminEmailTemplateDetail', params: { emailTemplateId: item.id } }"
          router
          small
          color="primary">
          Edit
        </v-btn>
      </template>
      <template v-slot:top>
        <v-text-field
          v-model="pagination.q"
          class="ma-2"
          density="compact"
          placeholder="Search templates..."
          hide-details></v-text-field>
      </template>
    </v-data-table-server>
  </v-container>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { IHeaderDTO, IPaginationDTO, PaginationDTO } from '@/dtos';
import type { VDataTableServer } from 'vuetify/components';
import { useEmailTemplateStore } from '@/stores/modules/admin/';
const headers = [
  { title: 'Subject', key: 'subject' },
  { title: 'Edit', key: 'action' },
] as IHeaderDTO[];
const emailTemplateStore = useEmailTemplateStore();
const loading = computed(() => emailTemplateStore.emailTemplatePaginationQuery.isLoading);
const emailTemplates = computed(() => emailTemplateStore.emailTemplatePaginationQuery.data);
const count = computed(() => emailTemplates.value?.length ?? 0);
const pagination = ref<IPaginationDTO>(new PaginationDTO());

const handleLimitChange = (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
  emailTemplateStore.pagination = pagination.value;
};
</script>
